

import React from 'react';
import { formatDate, DATE_FORMAT } from '@shootsta/get-moment';
import cx from 'classnames';
import { DATA_TABLE_COLUMN_DATA_TYPE } from '../../../common/constants/column/dataTableColumnDataType';
import { DATA_TABLE_ALIGN_HORIZONTAL } from '../../../common/constants/dataTableAlignHorizontal';
import {
  Button,
  ActionPopup,
  Text } from
'../../../ui-kit';

import ElevateList from '../components/common/ElevateList';

const TEMPLATE_TYPES = Object.freeze({
  STANDARD: 'Standard',
  BASIC: 'Basic'
});

export const getTemplatesDataTableColumns = ({
  onPublish,
  onUnPublish,
  options,
  isInternalAdmin,
  isMobile






}) => [
{
  field: 'templateName',
  header: 'Name',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getStyleModifiers: (rawValue, row) => ({
    customClassName: cx(
      'splash-page-data-table__cell',
      { 'splash-page-data-table__cell--published': row.status === 'PUBLISHED' })
  }),
  getValue: (rawValue, row) =>
  <div>
        <Text heading5>{row.templateName}</Text>
        <ElevateList isMobile={isMobile} splashRelations={row.SplashRelations} />
      </div>

},
...(!isMobile ? [
{
  field: 'type',
  header: 'Type',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getValue: (rawValue, row) =>
  <div>
          <Text>
            {
      row.templateType && TEMPLATE_TYPES[row.templateType] ?
      TEMPLATE_TYPES[row.templateType] :
      ''}

          </Text>
        </div>

},
...(
isInternalAdmin ? [{
  field: 'createdBy',
  header: 'Created By',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getValue: (rawValue, row) =>
  <div>{row.createdBy}</div>

}] : []),

{
  field: 'createdAt',
  header: 'Date Created',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  getValue: (rawValue, row) =>
  <div>{formatDate(row.createdAt, DATE_FORMAT.MONTH_SHORT_DAY_YEAR)}</div>

},
{
  field: 'status',
  header: '',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  isSortable: false,
  alignHorizontal: DATA_TABLE_ALIGN_HORIZONTAL.CENTER,
  getValue: (rawValue, row) => {
    if (row.status === 'PUBLISHED') {
      return (
        <Button type="TERTIARY" className="action-button" onClick={() => onUnPublish(row.templateId)} disabled={!!row.archivedAt}>
              Disable
            </Button>);

    }
    return (
      <Button type="SECONDARY" className="action-button" onClick={() => onPublish(row.templateId)} disabled={!!row.archivedAt}>
            Enable
          </Button>);

  }
}] :
[]),
{
  field: 'templateId',
  header: '',
  dataType: DATA_TABLE_COLUMN_DATA_TYPE.TEXT,
  isSortable: false,
  getValue: (rawValue, row) =>
  <ActionPopup
    options={options(row.templateId, row.status, row.archivedAt)} />


}];